var _rect, _rect2, _rect3, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDepartmentBookStatistics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.90039,
    y: 39.2031,
    width: 8.2,
    height: 11.8,
    stroke: "#444444",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2998,
    y: 31,
    width: 8.2,
    height: 20,
    stroke: "#444444",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 37.7002,
    y: 16.2031,
    width: 8.2,
    height: 34.8,
    stroke: "#444444",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97323 31.4661C5.67838 31.7571 5.67521 32.2319 5.96614 32.5268C6.25707 32.8216 6.73193 32.8248 7.02677 32.5339L5.97323 31.4661ZM29.1 9.7L29.6303 9.16967L29.1035 8.64287L28.5732 9.16614L29.1 9.7ZM33.4 14L32.8697 14.5303L33.398 15.0586L33.9283 14.5324L33.4 14ZM47.25 1.00287C47.2516 0.588663 46.9171 0.251593 46.5029 0.250006L39.7529 0.224144C39.3387 0.222557 39.0016 0.557054 39.0001 0.971265C38.9985 1.38548 39.333 1.72255 39.7472 1.72413L45.7471 1.74712L45.7241 7.74708C45.7226 8.16129 46.0571 8.49836 46.4713 8.49994C46.8855 8.50153 47.2225 8.16703 47.2241 7.75282L47.25 1.00287ZM7.02677 32.5339L29.6268 10.2339L28.5732 9.16614L5.97323 31.4661L7.02677 32.5339ZM28.5697 10.2303L32.8697 14.5303L33.9303 13.4697L29.6303 9.16967L28.5697 10.2303ZM33.9283 14.5324L47.0283 1.53236L45.9717 0.467642L32.8717 13.4676L33.9283 14.5324Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 50.25C1.08579 50.25 0.75 50.5858 0.75 51C0.75 51.4142 1.08579 51.75 1.5 51.75L1.5 50.25ZM1.5 51.75L51.5 51.75L51.5 50.25L1.5 50.25L1.5 51.75Z",
    fill: "#444444"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentBookStatistics);
export default __webpack_public_path__ + "static/media/Department Book Statistics.e9fa122016b2213ed7897abc04001dbd.svg";
export { ForwardRef as ReactComponent };